export default "__VITE_ASSET__Dflr8cpC__"